import { ApplicationElement, html } from '../application_element/element.js';
import '../icon/element.js';
import style from './style.lit.css';

/**
 * Element with an icon and 3 slots for title, description and actions
 *
 * @slot title - Has header text content
 * @slot short - Has subtitle text content
 * @slot actions - Button(s)
 */

export default class Hero2 extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    icon: { type: String },
  };

  render() {
    return html`
      ${this.icon && html`<ef-icon name=${this.icon}></ef-icon>`}
      <slot name="title"></slot>
      <slot name="short"></slot>
      <slot name="actions"></slot>
    `;
  }
}

customElements.get('ef-hero-2') || customElements.define('ef-hero-2', Hero2);
